export const _LOAD_MODEL_ = 'Load:LeadModel';

export const MODEL = {
  id: null,
  name: '',
  cnpj: null,
  city: null,
  email: '',
  responsible: '',
  state: null,
  phone: null,
  status: null,
  country: 'Brasil',
  zipcode: null,
  street: null,
  number: null,
  district: null,
  product_interest: [],
  kit_description: null,
  kit_quantity: null,
  kit_condition: null,
  contact_by: [],
  segment: [],
  created: null,
  company_details: {
    social_capital: null,
    started_at: null,
    registration_status: null,
    primary_cnae: null,
    secondary_cnaes: null,
  },
};
